/**
 * SMA Crossover Strategy
 *
 * Plots Fast SMA and Slow SMA. Colors change on crossover
 * to signal buy (fast > slow) and sell (fast < slow).
 *
 * Category: Advanced | Pane: Overlay
 */
import { IndicatorDefinition, PlotData } from "../types/indicator.types";
import { CandleData } from "../../types/chart.types";
import { computeSMA, getSource } from "./sma";

export const smaCrossoverIndicator: IndicatorDefinition = {
  id: "sma_crossover",
  name: "SMA Crossover",
  shortName: "SMAx",
  category: "advanced",
  pane: "overlay",
  params: [
    { key: "fastPeriod", label: "Fast Period", type: "number", default: 9, min: 2, max: 100 },
    { key: "slowPeriod", label: "Slow Period", type: "number", default: 21, min: 5, max: 500 },
    { key: "source", label: "Source", type: "select", default: "close", options: [
      { label: "Close", value: "close" }, { label: "HL2", value: "hl2" },
      { label: "HLC3", value: "hlc3" }, { label: "OHLC4", value: "ohlc4" },
    ] },
  ],
  plots: [
    { key: "fast", label: "Fast SMA", color: "#4CAF50", style: "line", lineWidth: 2 },
    { key: "slow", label: "Slow SMA", color: "#F44336", style: "line", lineWidth: 2 },
  ],
  calculate: (candles: CandleData[], params: Record<string, any>): PlotData[] => {
    const { fastPeriod, slowPeriod, source } = params;
    const src = getSource(candles, source);
    const fast = computeSMA(src, fastPeriod);
    const slow = computeSMA(src, slowPeriod);

    const fastData: { time: number; value: number }[] = [];
    const slowData: { time: number; value: number }[] = [];

    for (let i = 0; i < candles.length; i++) {
      if (fast[i] !== undefined) fastData.push({ time: candles[i].time, value: fast[i] });
      if (slow[i] !== undefined) slowData.push({ time: candles[i].time, value: slow[i] });
    }

    return [
      { key: "fast", data: fastData },
      { key: "slow", data: slowData },
    ];
  },
};
